import React from "react";

const services = [
  {
    title: "Digital Transformation",
    icon: "/service-icons/digital.svg",
    description: "Enable business transformation through modern platforms, process automation, and scalable architecture designed for future growth."
  },
  {
    title: "Cloud Technologies",
    icon: "/service-icons/cloud.svg",
    description: "Accelerate cloud adoption with secure, scalable solutions across AWS, Azure, Google Cloud, and hybrid enterprise environments."
  },
  {
    title: "Enterprise Applications",
    icon: "/service-icons/enterprise.svg",
    description: "Implement, upgrade, and support enterprise platforms including OpenText Documentum, content management systems, and integrated business solutions."
  },
  {
    title: "Data & Intelligence",
    icon: "/service-icons/data.svg",
    description: "Unlock the value of data through reporting, analytics, and intelligent insights that drive informed decision-making."
  },
  {
    title: "Cybersecurity & Identity",
    icon: "/service-icons/security.svg",
    description: "Protect enterprise systems with secure access, identity management, SSO, and compliance-driven solutions."
  },
  {
    title: "Quality Engineering",
    icon: "/service-icons/testing.svg",
    description: "Deliver high-performing systems through automation, performance testing, end-to-end validation, and production readiness."
  }
];

const technologies = [
  "OpenText Documentum", "OpenText D2", "OpenText InfoArchive", "OTDS / SSO",
  "Microsoft 365", "Azure", "AWS", "Google Cloud", "React", "Java", "Python",
  "Node.js", "Oracle", "SQL Server", "ServiceNow", "LoadRunner", "JMeter",
  "Selenium", "DevOps", "CI/CD"
];


const clients = [
  "Abbott",
  "Ascensus",
  "Beckman",
  "GAMMIS",
  "Lumen",
  "NYSDEC"
];

const jobs = [
  "Documentum / OpenText Consultant",
  "Performance Test Engineer",
  "Automation Engineer",
  "Cloud & DevOps Engineer",
  "Java Full Stack Developer",
  "Business Analyst"
];

function App() {
  return (
    <div className="site">
      <header className="header">
        <a href="#home" className="brand" aria-label="S3 Tech Systems home">
          <img src="/S3Tech.svg" alt="S3 Tech Systems Inc logo" className="logo" />
          <div className="brand-text">
            <span className="brand-name">S3 Tech Systems</span>
            <span className="brand-subtitle">Technology Consulting</span>
          </div>
        </a>

        <nav className="nav" aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#capabilities">Capabilities</a>
          <a href="#about">About</a>
          <a href="#clients">Clients</a>
          <a href="#careers">Careers</a>
        </nav>

        <a className="header-cta" href="#contact">Let’s Connect</a>
      </header>

      <main>
        <section id="home" className="hero-image-section">
          <img
            src="/hero-banner.png"
            alt="S3 Tech Systems technology consulting team collaboration hero banner"
            className="hero-banner-image"
          />
        </section>

        <section id="services" className="section">
          <div className="section-heading">
            <p className="eyebrow">Our Capabilities</p>
            <h2>Driving Enterprise Transformation Through Technology</h2>
            <p>
              We combine deep technical expertise with consulting excellence to deliver
              scalable, secure, and high-performing technology solutions across enterprise environments.
            </p>
          </div>
          <div className="grid cards">
            {services.map((service) => (
              <article className="service-card" key={service.title}>
                <div className="service-icon-wrap">
                  <img src={service.icon} alt="" className="service-icon" />
                </div>
                <div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="capabilities" className="section alt">
  <div className="section-heading">
    <p className="eyebrow">Technology Expertise</p>
    <h2>Core Technology Capabilities</h2>
    <p>
      Our expertise spans enterprise platforms, cloud engineering, and high-performance systems,
      enabling organizations to modernize and scale efficiently.
    </p>
  </div>

  <div className="grid cards">
    <div className="card">
      <h3>Enterprise Content Platforms</h3>
      <p>Documentum, D2, InfoArchive, OTDS and enterprise content ecosystems.</p>
    </div>

    <div className="card">
      <h3>Cloud & DevOps Engineering</h3>
      <p>Azure, AWS, CI/CD pipelines, and scalable cloud architectures.</p>
    </div>

    <div className="card">
      <h3>Quality & Performance Engineering</h3>
      <p>LoadRunner, JMeter, automation, and high-scale performance testing.</p>
    </div>

    <div className="card">
      <h3>Application Development</h3>
      <p>React, Node.js, Java-based enterprise applications and integrations.</p>
    </div>

    <div className="card">
      <h3>Data & Enterprise Systems</h3>
      <p>Oracle, SQL Server, ServiceNow, and enterprise data platforms.</p>
    </div>
  </div>
</section>

        <section id="about" className="section split">
          <div>
            <p className="eyebrow">About Us</p>
            <h2>A Trusted Partner in Enterprise Technology Consulting</h2>
          </div>
          <div>
            <p>
              S3 Tech Systems Inc is an IT and technology consulting firm focused on delivering
              high-quality solutions across enterprise environments.
            </p>
            <p>
              We specialize in supporting complex technology ecosystems, enabling organizations
              to modernize legacy systems, improve performance, and adopt scalable digital solutions.
            </p>
            <p>
              Our approach combines technical depth, delivery excellence, and a strong commitment
              to client success, making us a reliable partner for enterprise transformation initiatives.
            </p>
          </div>
        </section>

        <section id="clients" className="section">
          <div className="section-heading">
            <p className="eyebrow">Clients</p>
            <h2>Trusted by Organizations Across Industries</h2>
            <p>
              We have successfully delivered technology solutions and consulting services across
              enterprise, healthcare, public sector, and telecommunications organizations.
            </p>
          </div>

          <div className="client-slider" aria-label="Client names slider">
            <div className="client-track">
              {[...clients, ...clients].map((client, index) => (
                <div className="client-slide" key={`${client}-${index}`}>
                  {client}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="careers" className="section alt careers-section">
          <div className="careers-panel">
            <div className="careers-copy">
              <p className="eyebrow">Careers</p>
              <h2>Grow Your Career with S3 Tech Systems</h2>
              <p>
                We are always looking for talented consultants, engineers, analysts, and technology
                professionals who are passionate about solving enterprise technology challenges.
              </p>
              <p>
                Share your resume with us and our recruiting team will contact you when a matching
                opportunity becomes available.
              </p>
            </div>

            <div className="careers-action-card">
              <h3>Interested in joining us?</h3>
              <p>Send your resume and area of expertise to our careers team.</p>
              <a className="button primary" href="mailto:careers@s3techsystems.com?subject=Career%20Opportunity%20-%20S3%20Tech%20Systems">
                Submit Resume
              </a>
              <span className="career-note">careers@s3techsystems.com</span>
            </div>
          </div>
        </section>

        <section id="contact" className="section contact">
          <div>
            <p className="eyebrow">Contact Us</p>
            <h2>Let’s Build the Future Together</h2>
            <p>
              Connect with us to discuss consulting services, project delivery, or strategic
              technology initiatives. Our team is ready to support your business with scalable
              and reliable solutions.
            </p>
          </div>
          <div className="contact-card">
            <p><strong>Email:</strong> <a href="mailto:info@s3techsystems.com">info@s3techsystems.com</a></p>
            <p><strong>Careers:</strong> <a href="mailto:careers@s3techsystems.com">careers@s3techsystems.com</a></p>
            <p><strong>Website:</strong> www.s3techsystems.com</p>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© {new Date().getFullYear()} S3 Tech Systems Inc. All rights reserved.</p>
        <p className="footer-tagline">Delivering Technology. Enabling Transformation. Driving Results.</p>
      </footer>
    </div>
  );
}

export default App;
